/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { useState } from "react";
import { UniversalFiltersData } from "web/types/universal-filters";

/**
 * This hook looks after the two states and provides utility functions for
 * working with them
 */
export function useDualStates(initialState: UniversalFiltersData) {
    // This is the data for the current set of applied filters (eg without user
    //  changes) and is kept for the cancel button
    const [activeFilters, setActiveFilters] = useState(initialState);
    // This is the data for what is showing on the menu, fetched from rothko
    //  every so often
    const [displayedFilters, setDisplayedFilters] = useState(initialState);

    function revertDisplayedFilters(): void {
        setDisplayedFilters(activeFilters);
    }

    function applyDisplayedFilters(newFilters: UniversalFiltersData | undefined): void {
        // if we have just fetched the filters, we need to pass them in because the state
        // (displayedFilters) won't be updated until the next render
        setActiveFilters(newFilters || displayedFilters);
    }

    return {
        activeFilters,
        applyDisplayedFilters,
        displayedFilters,
        revertDisplayedFilters,
        setDisplayedFilters,
    };
}
